import { useEffect, useState } from "react";
import parse from "html-react-parser";
import CommentsStructure from "./CommentsStructure.js";
import CommentForm from "./CommentForm.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import logger from "../../../../utils/logger.js";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useComments } from "../../../../contexts/commentsContext/commentsContext.js";
import { decode } from "html-entities";

const CommentComponent = ({ itemId }) => {
  const { getFilesData, getMailMetaData, getMailId } = useMail();

  const { getAllCommentsData } = useComments();

  const [fileData, setFileData] = useState(null);

  const fetchFile = async (mailId, fileId) => {
    const response = await apiRequest(
      "Mails",
      "ReactGetMailFiles",
      {
        encryptedMailId: mailId,
        fileId: fileId,
      },
      "POST"
    );
    if (response.status === "success") {
      setFileData(response.data[fileId]);
    } else {
      logger(
        "lightboxContainer",
        "ReactGetMailFiles single file",
        response.data
      );
    }
  };

  useEffect(() => {
    if (itemId) {
      if (!getFilesData()[itemId]) {
        fetchFile(getMailId(), itemId);
      } else {
        setFileData(getFilesData()[itemId]);
      }
    }
  }, [itemId]);

  const bodyText = getMailMetaData().bodyText;
  const subjectText = getMailMetaData().subjectText;

  return getAllCommentsData() ? (
    <div className="sidebar-comment">
      <div className="email-subject-text">
        {itemId && fileData ? (
          <div className="relevant-file">
            <div className="file-image">
              {fileData?.ThumbSrc ? (
                <Icon src={fileData.ThumbSrc} />
              ) : (
                <Icon name="file" />
              )}
            </div>
            &#x200E;{fileData?.Name || ""}
          </div>
        ) : subjectText || bodyText ? (
          <>
            {subjectText ? decode(subjectText) : null}
            {bodyText && <div className="text">{parse(decode(bodyText))}</div>}
          </>
        ) : null}
      </div>
      <CommentsStructure {...{ itemId }} />
      <CommentForm {...{ itemId }} />
    </div>
  ) : (
    <div className="pagination-loader">
      <LoadingImageElement />
    </div>
  );
};

export default CommentComponent;
